import apiClient from '../config/axios';
import ENDPOINTS from '../constants/endpoints';

const pieceService = {
  // Get all pieces (no pagination, for selection)
  getAllPieces: async () => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.PIECES_RECHANGE}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la récupération des pièces',
        error: error.response?.data,
      };
    }
  },

  getPieces: async (pageSize = 10, page = 1, filters = {}) => {
    try {
      const params = {
        pageSize,
        page,
        ...filters,
      };
      const response = await apiClient.get(ENDPOINTS.PIECES_RECHANGE, { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la récupération des pièces',
        error: error.response?.data,
      };
    }
  },

  // Get piece by ID
  getPieceById: async (id) => {
    try {
      const response = await apiClient.get(`${ENDPOINTS.PIECES_RECHANGE}/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Erreur lors de la récupération de la pièce',
        error: error.response?.data,
      };
    }
  },

  // Create new piece
  createPiece: async (pieceData) => {
    try {
      // Ensure correct API body: famille (string), typeArticleId (array or comma string)
      const payload = {
        designation: pieceData.designation,
        famille: pieceData.famille,
        typeArticleId: Array.isArray(pieceData.typeArticleId)
          ? pieceData.typeArticleId.join(',')
          : pieceData.typeArticleId,
      };
      const response = await apiClient.post(ENDPOINTS.PIECES_RECHANGE, payload);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors de l'ajout de la pièce",
        error: error.response?.data,
      };
    }
  },

  // Update piece
  updatePiece: async (id, pieceData) => {
    try {
      // Ensure correct API body: famille (string), typeArticleId (array or comma string)
      const payload = {
        id,
        designation: pieceData.designation,
        famille: pieceData.famille,
        typeArticleId: Array.isArray(pieceData.typeArticleId)
          ? pieceData.typeArticleId.join(',')
          : pieceData.typeArticleId,
      };
      const response = await apiClient.put(ENDPOINTS.PIECES_RECHANGE, payload);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors de la modification de la pièce",
        error: error.response?.data,
      };
    }
  },

  // Delete piece
  deletePiece: async (id) => {
    try {
      const response = await apiClient.delete(`${ENDPOINTS.PIECES_RECHANGE}/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Erreur lors de la suppression de la pièce",
        error: error.response?.data,
      };
    }
  },
};

export default pieceService;